document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initPasosProgreso();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
  initComparador();
});

function initComparador() {
  var frames = document.querySelectorAll('[data-mt-comparador]');
  frames.forEach(function (frame) {
    var range = frame.querySelector('[data-mt-comp-range]');
    var before = frame.querySelector('[data-mt-comp-before]');
    var line = frame.querySelector('[data-mt-comp-line]');
    if (!range || !before || !line) return;
    function actualizar() {
      var val = range.value;
      before.style.clipPath = 'inset(0 ' + (100 - val) + '% 0 0)';
      line.style.left = val + '%';
    }
    range.addEventListener('input', actualizar);
    actualizar();
  });
}

function initGaleriaProducto() {
  var thumbs = document.querySelectorAll('[data-mt-thumb]');
  if (!thumbs.length) return;
  var principal = document.querySelector('[data-mt-imagen-principal]');
  if (!principal) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      var srcset = thumb.getAttribute('data-srcset');
      if (srcset) { principal.srcset = srcset; } else { principal.removeAttribute('srcset'); }
      principal.src = full;
      thumbs.forEach(function (t) { t.classList.remove('mt-activo'); });
      thumb.classList.add('mt-activo');
    });
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-mt-form]');
  forms.forEach(function (form) {
    var section = form.closest('.mt-producto');
    if (!section) return;
    var variantsScript = section.querySelector('[data-mt-variantes]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var optionButtons = section.querySelectorAll('[data-mt-opcion]');
    var idInput = section.querySelector('[data-mt-variant-id]');
    var precioEl = section.querySelector('[data-mt-precio]');
    var addBtn = section.querySelector('[data-mt-add]');
    var addTexto = section.querySelector('[data-mt-add-texto]');

    function seleccionActual() {
      var seleccion = [];
      optionButtons.forEach(function (opcion) {
        var activo = opcion.querySelector('.mt-activo');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = seleccionActual();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return seleccion.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price, section.getAttribute('data-mt-money-format'));
      if (addBtn) {
        addBtn.disabled = !variante.available;
        if (addTexto) addTexto.textContent = variante.available ? addBtn.getAttribute('data-texto-disponible') || addTexto.textContent : addBtn.getAttribute('data-texto-agotado') || addTexto.textContent;
      }
    }

    optionButtons.forEach(function (opcion) {
      var valores = opcion.querySelectorAll('[data-mt-valor]');
      valores.forEach(function (btn) {
        btn.addEventListener('click', function () {
          valores.forEach(function (b) { b.classList.remove('mt-activo'); });
          btn.classList.add('mt-activo');
          actualizar();
        });
      });
    });
  });
}

function formatoMoneda(centavos, formato) {
  var valor = (centavos / 100).toFixed(2);
  var partes = valor.split('.');
  partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  valor = partes.join('.');
  if (!formato) return valor;
  return formato.replace(/\{\{\s*amount\s*\}\}/, valor);
}

function initCantidadProducto() {
  var wraps = document.querySelectorAll('[data-mt-form]');
  wraps.forEach(function (form) {
    var input = form.querySelector('[data-mt-cant-input]');
    var menos = form.querySelector('[data-mt-cant-menos]');
    var mas = form.querySelector('[data-mt-cant-mas]');
    if (!input || !menos || !mas) return;
    menos.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    mas.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var counters = document.querySelectorAll('[data-mt-counter]');
  if (!counters.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var target = parseFloat(el.getAttribute('data-mt-counter')) || 0;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = target * eased;
        el.textContent = target % 1 === 0 ? Math.round(current) : current.toFixed(1);
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  counters.forEach(function (el) { observer.observe(el); });
}

function initPasosProgreso() {
  var wrap = document.querySelector('[data-mt-pasos]');
  if (!wrap) return;
  var items = wrap.querySelectorAll('[data-mt-paso]');
  if (!items.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
      }
    });
  }, { threshold: 0.4 });
  items.forEach(function (el) { observer.observe(el); });
}
